<template>
  <div
    class="group relative w-40 overflow-hidden rounded-lg border bg-white text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:bg-gray-950 dark:border-gray-800"
  >
    <div class="block w-full cursor-pointer text-left" role="button" tabindex="0" @click="handleClick" @keydown.enter.prevent="handleClick" @keydown.space.prevent="handleClick">
      <div class="relative h-32 w-full overflow-hidden bg-gray-100 dark:bg-gray-900">
        <img
          v-if="isImage"
          :src="upload.imageUrls.medium"
          :alt="upload.caption"
          class="object-cover w-full h-full"
        >

        <div v-else class="h-full w-full flex flex-col items-center justify-center font-semibold">
          <div class="h-10 w-10 rounded-lg bg-primary-100 dark:bg-primary-950 flex items-center justify-center mb-2">
            <o-icon icon="file" class="text-primary-700 dark:text-primary-300" :size="20" />
          </div>
          <span class="text-primary-700 dark:text-primary-300 uppercase text-xs">{{ upload.extension || $t('general.file') }}</span>
        </div>

        <div v-if="upload.reservation" class="absolute left-2 top-2 h-7 w-7 rounded bg-black/35 text-white flex items-center justify-center">
          <o-icon icon="reservation" />
        </div>
      </div>

      <div class="h-16 px-3 py-2">
        <p class="text-gray-800 dark:text-gray-100 leading-tight line-clamp-2 text-sm font-medium">
          {{ upload.caption || '-' }}
        </p>
        <p v-if="upload.size" class="mt-1 text-xs text-gray-500 dark:text-gray-400 leading-tight uppercase">
          <span>{{ upload.extension }}</span> - <span>{{ sizeLabel }}</span>
        </p>
      </div>
    </div>

    <div class="absolute right-2 top-2 flex items-center space-x-1 opacity-0 transition group-hover:opacity-100 group-focus-within:opacity-100">
      <o-button size="sm" flat icon="view" class="bg-white/90 shadow-sm dark:bg-gray-900/90" @click.stop="handleClick" />
      <o-button size="sm" flat icon="delete" class="bg-white/90 shadow-sm dark:bg-gray-900/90" @click.stop="handleDelete" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  upload: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'delete'): void
}>()

const sizeLabel = computed(() => {
  const upload = props.upload

  return upload.size > 1024
    ? upload.size > 1048576
      ? Math.round(upload.size / 1048576) + 'mb'
      : Math.round(upload.size / 1024) + 'kb'
    : upload.size + 'b'
})

const isImage = computed(() => {
  return !!props.upload.imageUrls
})

function handleClick () {
  emit('click')
}

function handleDelete () {
  emit('delete')
}
</script>
